// components/Risk/WaterRequestsList.jsx
import { API_URL } from "../../config";
import { authFetch } from "../../utils";
import useGetWaterRequests from "../../hooks/useGetWaterRequests";

export default function WaterRequestsList({ hook } = {}) {
  const ownHook = useGetWaterRequests();
  const { waterRequests, setWaterRequests, isLoading: loadingRequests } = hook ?? ownHook;

  const cancelRequest = async (requestId, label) => {
    // Ver si hay otro riego pendiente ANTES de cancelar
    const remaining = waterRequests.filter(req => req._id !== requestId);
    const nextRequest = remaining[0];

    let confirmMessage = `¿Seguro que quieres cancelar el riego programado de ${label}?`;

    if (nextRequest) {
      const nextLabel = `${getDayLabel(nextRequest.date)} ${nextRequest.fwiZone.name}`;
      confirmMessage += `\n\n⚠️ Atención: hay otro riego pendiente (${nextLabel}).`;
    }

    const confirmed = window.confirm(confirmMessage);
    if (!confirmed) return;

    try {
      const res = await authFetch(`${API_URL}fwi/water-request/${requestId}/disable`, {
        method: "PUT"
      });

      if (!res.ok) throw new Error("Error al cancelar el riego programado");

      setWaterRequests(remaining);
      alert(`Riego cancelado: ${label}`);

    } catch (err) {
      console.error("Error cancelando el riego programado:", err);
      alert("No se pudo cancelar el riego programado");
    }
  };

  function getDayLabel(dateString) {
    const date = new Date(dateString);

    const today = new Date();
    today.setHours(0,0,0,0);

    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(0,0,0,0);

    const target = new Date(date);
    target.setHours(0,0,0,0);

    if (target.getTime() === today.getTime()) return "Hoy a las 6:00";
    if (target.getTime() === tomorrow.getTime()) return "Mañana a las 6:00";

    return null;
  }

  const firstRequest = waterRequests[0];

  return (
    <div style={{ marginTop: '18px' }}>
      <strong>Riegos programados</strong>

      {loadingRequests && <div>Cargando...</div>}

      {!loadingRequests && !firstRequest && (
        <div style={{ fontSize: '12px', opacity: 0.7 }}>
          No hay riegos programados
        </div>
      )}

      {!loadingRequests && firstRequest && (
        <ul style={{ paddingLeft: '16px', marginTop: '6px' }}>
          <li
            key={firstRequest._id}
            style={{
              fontSize: '13px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '4px'
            }}
          >
            <span>
              {getDayLabel(firstRequest.date)} {firstRequest.fwiZone.name}{firstRequest.priority === 1 ? ' (forzado)' : ''}
            </span>

            <button
              onClick={() =>
                cancelRequest(
                  firstRequest._id,
                  `${getDayLabel(firstRequest.date)} ${firstRequest.fwiZone.name}`
                )
              }
              style={{
                marginLeft: '10px',
                padding: '2px 6px',
                fontSize: '12px',
                cursor: 'pointer',
                backgroundColor: '#d9534f',
                color: 'white',
                border: 'none',
                borderRadius: '4px'
              }}
            >
              Cancelar
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}
